import { axiosRequest } from '@/util/axios-request';
// 获取子项目-付薪月份list
export var getPayMonthList = function getPayMonthList(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/getPayMonthList',
    method: 'POST',
    data: data
  });
};

// 子项目列表list
export var payrollSubProjectList = function payrollSubProjectList(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/list',
    method: 'GET',
    params: data
  });
};

// 子项目列表list_sort
export var sortSubProject = function sortSubProject(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/sortSubProject',
    method: 'POST',
    data: data
  });
};

// 项目添加&编辑
export var payrollProjectSave = function payrollProjectSave(data) {
  return axiosRequest({
    url: '/web/payroll_project/save',
    method: 'POST',
    params: data
  });
};

// 项目列表
export var payrollProjectList = function payrollProjectList(data) {
  return axiosRequest({
    url: '/web/payroll_project/list',
    method: 'GET',
    params: data
  });
};

// 项目详情
export var payrollProjectDetail = function payrollProjectDetail(data) {
  return axiosRequest({
    url: '/web/payroll_project/read',
    method: 'GET',
    params: data
  });
};

// 子项目创建
export var payrollSubProjectCreate = function payrollSubProjectCreate(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/create',
    method: 'POST',
    data: data
  });
};

// 获取当前正在进行中的任务数量Cout
export var getPendingTaskCount = function getPendingTaskCount(data) {
  return axiosRequest({
    url: '/web/background_task/getPendingTaskCount',
    method: 'GET',
    params: data
  });
};

// 获取完成任务list
export var getCompletedTaskList = function getCompletedTaskList(data) {
  return axiosRequest({
    url: '/web/background_task/getCompletedTaskList',
    method: 'GET',
    params: data
  });
};

// 获取进行任务list
export var getPendingTaskList = function getPendingTaskList(data) {
  return axiosRequest({
    url: '/web/background_task/getPendingTaskList',
    method: 'GET',
    params: data
  });
};

// 同步计薪方案 到 子项目
export var schemeToSubProject = function schemeToSubProject(data) {
  return axiosRequest({
    url: '/web/payroll_rule/syncSchemeRuleToSubProject',
    method: 'POST',
    data: data
  });
};

// 计薪方案-获取list-by settlement_type
export var getListByType = function getListByType(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/getListByType',
    method: 'get',
    params: data
  });
};

// 工资计算-获取scheme 全部设置
export var getSettingInfo = function getSettingInfo(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_scheme/getSettingInfo',
    method: 'get',
    params: data
  });
};

// 子项目删除
export var payrollSubProjectDelete = function payrollSubProjectDelete(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/remove',
    method: 'get',
    params: data
  });
};

// 子项目删除
export var getAllSubProjectListGroupByPayMonth = function getAllSubProjectListGroupByPayMonth(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/getAllSubProjectListGroupByPayMonth',
    method: 'POST',
    data: data
  });
};

// 子项目归档
export var payrollSubProjectOnFile = function payrollSubProjectOnFile(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/onFile',
    method: 'POST',
    params: data
  });
};

// 子项目取消归档
export var payrollSubProjectCancelOnFile = function payrollSubProjectCancelOnFile(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/cancelOnFile',
    method: 'POST',
    params: data
  });
};

// 子项目 取消归档 提示
export var getCancelOnFileNotice = function getCancelOnFileNotice(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/getCancelOnFileNotice',
    method: 'POST',
    params: data
  });
};

// 子项目 归档 提示
export var getOnFileNotice = function getOnFileNotice(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/getOnFileNotice',
    method: 'POST',
    params: data
  });
};

// 子项目基本信息
export var payrollSubProjectInfo = function payrollSubProjectInfo(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/viewBaseInfo',
    method: 'GET',
    params: data
  });
};

// 子项目基本信息
export var savePayrollSubProject = function savePayrollSubProject(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/save',
    method: 'POST',
    data: data
  });
};

// 子项目-list -header-coloums
export var getListHeaderColumns = function getListHeaderColumns(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/getListHeaderColumns',
    method: 'POST',
    data: data
  });
};

// 子项目员工列表
export var payrollSubStaffList = function payrollSubStaffList(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/list',
    method: 'GET',
    params: data
  });
};

// 子项目员工编辑
export var payrollSubStaffSave = function payrollSubStaffSave(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/save',
    method: 'POST',
    data: data
  });
};

// 子项目员工删除
export var payrollSubStaffDelete = function payrollSubStaffDelete(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/remove',
    method: 'POST',
    data: data
  });
};

// 子项目添加员工
export var payrollSubStaffAdd = function payrollSubStaffAdd(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/add',
    method: 'POST',
    data: data
  });
};

// 同步staff_item 到 sub project staff_item
export var syncStaffItem = function syncStaffItem(data) {
  return axiosRequest({
    url: '/web/payroll_rule/syncStaffItem',
    method: 'POST',
    data: data
  });
};

// 子项目-清空所有员工的税
export var clearSalaryMonthTax = function clearSalaryMonthTax(data) {
  return axiosRequest({
    url: '/web/payroll_rule//clearSalaryMonthTax',
    method: 'post',
    params: data
  });
};

// 子项目-批量修改税-模版
export var exportTaxExcel = function exportTaxExcel(data) {
  return axiosRequest({
    url: '/web/payroll_rule/export_tax_excel',
    method: 'get',
    params: data
  });
};

// 子项目员工薪资信息详情
export var payrollSubStaffDetail = function payrollSubStaffDetail(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/read',
    method: 'GET',
    params: data
  });
};
// 子项目员工薪资信息保存
export var payrollSubStaffDetailSave = function payrollSubStaffDetailSave(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/save',
    method: 'POST',
    data: data
  });
};

// 银行列表
export var payrollBanks = function payrollBanks(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/bankItem',
    method: 'GET',
    params: data
  });
};

// 员工薪资列表
export var payrollStaffList = function payrollStaffList(data) {
  return axiosRequest({
    url: '/web/payroll_staff/list',
    method: 'GET',
    params: data
  });
};

// 员工调薪记录
export var payrollStaffHistory = function payrollStaffHistory(data) {
  return axiosRequest({
    url: '/web/payroll_staff/changepaylist',
    method: 'GET',
    params: data
  });
};

// 员工调薪记录
export var payrollStaffInfo = function payrollStaffInfo(data) {
  return axiosRequest({
    url: '/web/payroll_staff/read',
    method: 'GET',
    params: data
  });
};

// 员工薪资信息保存
export var payrollStaffSave = function payrollStaffSave(data) {
  return axiosRequest({
    url: '/web/payroll_staff/save',
    method: 'post',
    data: data
  });
};

// 导出员工薪资数据
export var payrollStaffExport = function payrollStaffExport(data) {
  return axiosRequest({
    url: '/web/payroll_staff/exportPayInfoData',
    method: 'GET',
    params: data
  });
};

// 校验年度收入是否要归档
export var checkYearIncomeArchive = function checkYearIncomeArchive(data) {
  return axiosRequest({
    url: '/web/payroll_staff/checkYearIncomeArchive',
    method: 'POST',
    data: data
  });
};

// 归档年度累计值
export var saveYearIncomeArchive = function saveYearIncomeArchive(data) {
  return axiosRequest({
    url: '/web/payroll_staff/saveYearIncomeArchive',
    method: 'POST',
    data: data
  });
};

// 员工薪资信息导出模版
export var payrollStaffTpl = function payrollStaffTpl(data) {
  return axiosRequest({
    url: '/web/payroll_staff/downloadStaffPayInfoTpl',
    method: 'GET',
    params: data
  });
};

// 子项目员工薪资信息模板导出
export var downloadStaffPayInfoTpl = function downloadStaffPayInfoTpl(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/downloadStaffPayInfoTpl',
    method: 'GET',
    params: data
  });
};

// 同上
export var downloadStaffPayInfoTplNew = function downloadStaffPayInfoTplNew(data) {
  return axiosRequest({
    url: '/web/payroll_rule/export_staff_excel',
    method: 'GET',
    params: data
  });
};

// 子项目员工保存行数据
export var saveItemInfo = function saveItemInfo(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/save_item',
    data: data
  });
};

// 薪资设置-导出/展示可选字段树
export var getPayrollSettingExcelItems = function getPayrollSettingExcelItems(data) {
  return axiosRequest({
    url: '/web/payroll_setting/getExcelItems',
    method: 'GET',
    params: data
  });
};

// 暂存薪资展示项-回显
export var getStorageSalaryItem = function getStorageSalaryItem(data) {
  return axiosRequest({
    url: '/web/payroll_setting/getStorageSalaryItem',
    method: 'GET',
    params: data
  });
};

// 暂存薪资展示项-保存
export var setStorageSalaryItem = function setStorageSalaryItem(data) {
  return axiosRequest({
    url: '/web/payroll_setting/setStorageSalaryItem',
    method: 'POST',
    data: data
  });
};

// 计算工资
export var downloadPaySheet = function downloadPaySheet(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/downloadPaySheet',
    method: 'GET',
    params: data,
    timeout: null
  });
};

// 子项目-计算状态
export var getSubProjectCalculateState = function getSubProjectCalculateState(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/getSubProjectCalculateState',
    data: data,
    timeout: null
  });
};

// 生成工资表
export var calculate = function calculate(data) {
  return axiosRequest({
    url: '/web/payroll_rule/calculate',
    data: data,
    timeout: null
  });
};

// 员工薪资信息导入
export var payrollStaffImport = function payrollStaffImport(data) {
  return axiosRequest({
    url: '/web/payroll_staff/uploadStaffPayInfoFile',
    method: 'post',
    params: data
  });
};

// 子员工薪资信息模板
export var payrollSubStaffTpl = function payrollSubStaffTpl(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/downloadStaffPayInfoTpl',
    method: 'post',
    params: data
  });
};

// 子员工薪资信息导入
export var payrollSubStaffImport = function payrollSubStaffImport(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/uploadStaffPayInfoData',
    method: 'post',
    data: data
  });
};
// 员工薪资信息列表
export var payrollStaffDetail = function payrollStaffDetail(data) {
  return axiosRequest({
    url: '/web/payroll_staff/read',
    method: 'GET',
    params: data
  });
};

// 员工薪资信息保存
export var payrollStaffDetailSave = function payrollStaffDetailSave(data) {
  return axiosRequest({
    url: '/web/payroll_staff/save',
    method: 'post',
    data: data
  });
};

// 子员工薪资信息模板
export var payrollKaoqinDownFn = function payrollKaoqinDownFn(data) {
  return axiosRequest({
    url: '/web/payroll_rule/export_attendance_excel',
    method: 'get',
    params: data
  });
};

// 生成考勤数据
export var generateAttendance = function generateAttendance(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/generateAttendance',
    method: 'post',
    data: data
  });
};

// 自定义项
export var itemlist = function itemlist(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/itemlist',
    method: 'get',
    params: data
  });
};

// 创建自定义薪资项
export var createitem = function createitem(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/createitem',
    method: 'post',
    data: data
  });
};

// update自定义薪资项
export var updateitem = function updateitem(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project/updateitem',
    method: 'post',
    data: data
  });
};

// 合并生成工资表
export var downloadPaySheetCombined = function downloadPaySheetCombined(data) {
  return axiosRequest({
    url: '/web/payroll_sub_project_staff/downloadPaySheetCombined',
    data: data
  });
};

// 员工调薪read
export var readUpdateSalary = function readUpdateSalary(data) {
  return axiosRequest({
    url: '/web/payroll_staff/readUpdateSalary',
    method: 'GET',
    params: data
  });
};

// 员工调薪save
export var saveUpdateSalary = function saveUpdateSalary(data) {
  return axiosRequest({
    url: '/web/payroll_staff/saveUpdateSalary',
    method: 'POST',
    data: data
  });
};

// 调薪历史log_ 修改接口
export var saveUpdateLDateLog = function saveUpdateLDateLog(data) {
  return axiosRequest({
    url: '/web/payroll_staff/resetStaffSalaryUpdateLDateLog',
    method: 'POST',
    data: data
  });
};

// 调薪原因type列表
export var updateSalaryReasonTypeList = function updateSalaryReasonTypeList(data) {
  return axiosRequest({
    url: '/web/payroll_staff/getUpdateSalaryReasonTypeList',
    method: 'GET',
    params: data
  });
};

// 员工调薪记录
export var getStaffUpdateSalaryDetailList = function getStaffUpdateSalaryDetailList(data) {
  return axiosRequest({
    url: '/web/payroll_staff/getStaffUpdateSalaryDetailList',
    method: 'get',
    params: data
  });
};

// 批量调薪-list
export var getBatchUpdateSalaryList = function getBatchUpdateSalaryList(data) {
  return axiosRequest({
    url: '/web/payroll_staff/getBatchUpdateSalaryList',
    method: 'POST',
    data: data
  });
};

// 批量调薪-保存调薪数据
export var saveBatchUpdateSalaryData = function saveBatchUpdateSalaryData(data) {
  return axiosRequest({
    url: '/web/payroll_staff/saveBatchUpdateSalaryData',
    method: 'POST',
    data: data
  });
};

// 调薪历史log
export var getLogList = function getLogList(data) {
  return axiosRequest({
    url: '/web/payroll_staff/getStaffSalaryUpdateDateLogList',
    method: 'GET',
    params: data
  });
};

// 调薪历史log_ 新增调薪或者编辑调薪的时候
export var getSalaryNotice = function getSalaryNotice(data) {
  return axiosRequest({
    url: '/web/payroll_staff/getUpdateSalaryNotice',
    method: 'GET',
    params: data
  });
};

// 调薪历史log_ 撤销
export var repealSalaryDate = function repealSalaryDate(data) {
  return axiosRequest({
    url: '/web/payroll_staff/repealStaffSalaryUpdateLDate',
    method: 'POST',
    data: data
  });
};

// 调薪历史log_detail
export var getLogDetail = function getLogDetail(data) {
  return axiosRequest({
    url: '/web/payroll_staff/getStaffSalaryUpdateDateLogDetail',
    method: 'GET',
    params: data
  });
};

// 批量调薪-下载员工excel 模版
export var downloadBatchUpdateSalaryTpl = function downloadBatchUpdateSalaryTpl(data) {
  return axiosRequest({
    url: '/web/payroll_staff/downloadBatchUpdateSalaryTpl',
    method: 'POST',
    data: data
  });
};

// 批量调薪-上传员工excel
export var uploadBatchUpdateSalaryData = function uploadBatchUpdateSalaryData(data) {
  return axiosRequest({
    url: '/web/payroll_staff/uploadBatchUpdateSalaryData',
    method: 'POST',
    data: data
  });
};

// 员工调薪详情_type
export var getStaffUpdateSalaryDetailType = function getStaffUpdateSalaryDetailType(data) {
  return axiosRequest({
    url: '/web/payroll_staff/getStaffUpdateSalaryDetailType',
    method: 'post',
    data: data
  });
};